// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SendOverlay_overlay__30CsA","content":"SendOverlay_content__5hrhs","or":"SendOverlay_or__1tCbj","trigger":"SendOverlay_trigger__3S7uA"};